module.exports = __webpack_public_path__ + "img/4.1c0384eb.png";